import { useMutation, useQuery, UseQueryOptions } from 'react-query'
import { queryClient } from '../../features/react-query-provider'
import { UserReport, useUserReportAPI } from '../api/v2/UserReportAPI'

export const useUserReport = (options?: UseQueryOptions<UserReport>) => {
  const { getUserReport } = useUserReportAPI()
  return useQuery(['user-report'], () => getUserReport(), options)
}

export const useRunUserReportJob = () => {
  const { runUserReportJob } = useUserReportAPI()
  return useMutation(() => runUserReportJob(), {
    onSuccess: () => queryClient.invalidateQueries(['user-report'])
  })
}
